import { FC, ReactNode } from 'react';
import {
  IconTextButtonProps,
  IconButtonVariant,
  IconButtonType,
} from './IconTextButton.types';
import styles from './icon-text-button.module.scss';
import Typography from '../Typography/Typography';
import { TypographyProps } from '../Typography/Typography.types';

const IconTextButton: FC<IconTextButtonProps> = ({
  onClickHandler,
  href,
  disabled = false,
  icon,
  label,
  variant = 'primary',
}) => {
  const Icon = icon;

  const typographyMap = {
    primary: { variant: 'body-2', color: 'midnight' },
    secondary: { variant: 'body-4', color: 'midnight-60' },
  } as const satisfies Record<
    IconButtonVariant,
    Pick<TypographyProps, 'variant' | 'color'>
  >;

  const buttonType: IconButtonType = href?.length
    ? 'link'
    : onClickHandler
      ? 'action'
      : 'text';

  const ContentWrapper = ({
    children,
  }: {
    children: ReactNode;
  }): JSX.Element => {
    switch (buttonType) {
      case 'link':
        return (
          <a
            className={styles.contentWrapperButton}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {children}
          </a>
        );
      case 'action':
        return (
          <button
            className={styles.contentWrapperButton}
            onClick={onClickHandler}
            disabled={disabled}
          >
            {children}
          </button>
        );
      default:
        return <div className={styles.contentWrapperDiv}>{children}</div>;
    }
  };

  return (
    <div className={`${styles.container} ${styles[variant]}`}>
      <ContentWrapper>
        <div className={styles.iconWrapper}>
          <Icon />
        </div>
        <Typography
          variant={typographyMap[variant].variant}
          format="none"
          color={typographyMap[variant].color}
        >
          {label}
        </Typography>
      </ContentWrapper>
    </div>
  );
};

export default IconTextButton;
